import { render, staticRenderFns } from "./BoxChartItem.vue?vue&type=template&id=10d7054a&scoped=true&"
import script from "./BoxChartItem.vue?vue&type=script&lang=js&"
export * from "./BoxChartItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxChartItem.vue?vue&type=style&index=0&id=10d7054a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7054a",
  null
  
)

export default component.exports